import { render } from "./ProjectDetailView.vue?vue&type=template&id=9baacf08"
import script from "./ProjectDetailView.vue?vue&type=script&lang=js"
export * from "./ProjectDetailView.vue?vue&type=script&lang=js"

import "./ProjectDetailView.vue?vue&type=style&index=0&id=9baacf08&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__